import { AppModule } from '@app/app.module';
import { BadgeService } from '@internal-services/badge.service';
import { validateACL } from '@shared-libs/acl';
import { INavigationRoute } from '@shared-libs/interfaces';

const badgeService = AppModule.injector.get(BadgeService);

export const getMobileInternalNavigationRoutes = (): Array<INavigationRoute> =>
	[].filter((route) => validateACL(`/internal${route.route}`));

export const getDesktopInternalNavigationRoutes = (): Array<INavigationRoute> =>
	[
		{
			route: '/start',
			icon: 'home-outline',
			nameKey: 'START',
			highlight: true,
		},
		{
			route: '/kalender',
			icon: 'calendar-outline',
			nameKey: 'CALENDAR',
			highlight: true,
		},
		{
			route: '/beego',
			icon: 'beego-outline',
			nameKey: 'BEEGO',
			highlight: true,
		},
		{
			route: '/beoordelingen',
			icon: 'star-outline',
			nameKey: 'RATINGS',
			highlight: true,
		},
		{
			route: '/uitleendienst',
			icon: 'device-outline',
			nameKey: 'LOAN_SERVICE',
			highlight: true,
		},
		{
			route: '/wachtlijst',
			icon: 'alarm-time-outline',
			nameKey: 'WAIT_LIST',
			highlight: true,
		},
		{
			route: '/clienten',
			icon: 'clients-outline',
			nameKey: 'CLIENTS',
			highlight: true,
		},
		{
			route: '/statistieken',
			icon: 'statistics-outline',
			nameKey: 'STATISTICS',
			highlight: true,
		},
		{
			route: '/medewerkers',
			icon: 'employees-outline',
			nameKey: 'EMPLOYEES',
			highlight: false,
		},
		{
			route: '/administratie',
			icon: 'administration-outline',
			nameKey: 'ADMINISTRATION',
			highlight: false,
		},
		{
			route: '/hulpmiddelen',
			icon: 'tools-outline',
			nameKey: 'TOOLS',
			highlight: false,
			badge: badgeService.getReleaseNotesBadge(),
		},
		{
			route: '/digibank',
			icon: 'info-outline',
			nameKey: 'DIGIBANK',
			highlight: false,
		},
	].filter((route) => validateACL(`/internal${route.route}`));
